module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/S269bp/tc-custom/9783988262400.jpg?1736354546795",
      "alt": "This image is the cover for the book Amazing Stories Volume 143, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Amazing Stories Volume 143, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Amazing Stories Volume 143 is a great collection of action short stories from \"The Golden Age of Science Fiction\". Featured here are five short stories by different authors: \"Bombs Awry\" by George O. Smith, \"Daughter\" by Philip José Farmer, \"If At First\" by Bill Venable, \"Flight Eighteen\" by Paul A. Torak and one story by Mike Curry, \"Metamorphosis\".")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      George O. Smith\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("George O. Smith (1911-1981) was an American science fiction author who wrote primarily in the 1940s and 1950s. He was known for his technical knowledge and attention to detail in his stories, which often focused on the interactions between science and society. Smith's most famous work is probably \"The Fourth 'R',\" which introduced the concept of a \"psychohistorian,\" a character who could use advanced mathematics and psychology to predict the behavior of large groups of people. He was also an active member of science fiction fandom, serving as the chairman of the first World Science Fiction Convention in 1939.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0